import { createRoot } from "react-dom/client";
import { LaunchHero } from "@/app/components/launch/LaunchHero";
import { LaunchOffer } from "@/app/components/launch/LaunchOffer";
import { FAQSection } from "@/app/components/FAQSection";
import { Footer } from "@/app/components/Footer";
import "@/styles/index.css";

function LaunchPage() {
  return (
    <div className="relative bg-[#0B0E14] overflow-x-hidden">
      <LaunchHero />
      <LaunchOffer />
      <FAQSection />
      <Footer />
    </div>
  );
}

createRoot(document.getElementById("root")!).render(<LaunchPage />);
